import React from "react";
import { Box, Grid, Typography, Container, useTheme } from "@mui/material";
import InfoSection from "../../shared/InfoSection";
import img from "../../../assets/images/circle-info.png";
import service1 from "../../../assets/images/service1.png";
import service2 from "../../../assets/images/service2.png";
import CustomButton from "../../shared/CustomButton";
import { useTranslation } from "react-i18next";
import useNavigation from "../../../hooks/useNavigation";
const logos = [
  { src: service2, alt: "Ministry of Commerce Logo" },
  { src: service1, alt: "SOCPA Logo" },
];
const ZakatConsultancySection = ({ data }) => {
  const theme = useTheme();
  const { i18n, t } = useTranslation();
  const currentLang = i18n.language;
  const { navigateTo } = useNavigation();
  const locale = i18n.language || localStorage.getItem("language") || "en";

  const handleAboutUS = () => {
    navigateTo(`/${locale}/about`);
  };
  return (
    <Container maxWidth="lg" id="targetSectionId" sx={{ pt: "60px" }}>
      <Box
        sx={{
          textAlign: "center",
          padding: "32px 0",
        }}
      >
        <Grid
          container
          spacing={{ xs: 1, sm: 3 }}
          justifyContent="center"
          alignItems="stretch"
        >
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                borderRadius: "8px",
                display: "flex",
                justifyContent: { xs: "", lg: "center" },
                alignItems: "center",
                overflow: "hidden",
              }}
            >
              <img
                src={data?.image}
                alt="Company Building"
                style={{
                  borderRadius: "8px",
                  width: "100%",
                  height: "608px",
                  maxWidth: "479px",
                  objectFit: "cover",
                }}
              />
            </Box>
          </Grid>

          <Grid
            item
            xs={12}
            md={6}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              height: "100%",
            }}
          >
            <InfoSection
              icon={img}
              title={t("buttons.Who We Are")}
              description={data?.title[currentLang]}
              align="flex-start"
              textAlign={currentLang === "ar" ? "right" : "left"}
            />

            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                gap: { xs: 0.5, sm: 2, md: 2 },
                marginTop: { xs: "30px", md: "5px", lg: "40px" },
                marginBottom: { xs: "30px", md: "5px", lg: "40px" },
                flexDirection: { xs: "column", sm: "row" },
                alignItems: "center",
                width: "100%",
              }}
            >
              {logos.map(({ src, alt, width, height }, index) => (
                <Box
                  key={index}
                  sx={{
                    width: { xs: "90%", sm: "180px", md: "256px" },
                    height: { xs: "auto", md: "88px" },
                    border: "1px solid #D6D8DB",
                    borderRadius: "12px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: 1,
                    marginBottom: { xs: 2, md: 0 },
                  }}
                >
                  <img
                    src={src}
                    alt={alt}
                    width={width || "182"}
                    height={height || "85"}
                    loading="lazy"
                    style={{
                      width: "100%",
                      maxWidth: "182px",
                      maxHeight: "85px",
                      marginRight: alt === "SOCPA Logo" ? "8px" : "0px",
                      objectFit: "contain",
                    }}
                  />
                </Box>
              ))}
            </Box>

            <Typography
              sx={{
                color: theme.palette.primary.body,
                fontWeight: "400",
                fontSize: "18px",
                lineHeight: "27px",
                marginBottom: { xs: "30px", md: "5px", lg: "35px" },
                textAlign: currentLang === "ar" ? "right" : "left",
              }}
            >
              {data?.description[currentLang]}
            </Typography>
            <CustomButton
              backgroundImage="linear-gradient(90deg, #0A1F52 0%, #1646B8 100%)"
              onClick={handleAboutUS}
            >
              {t("buttons.Learn More About Us")}
            </CustomButton>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default ZakatConsultancySection;
